/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import a from "prop-types";
import { validatePackage as l, classNames as n } from "@progress/kendo-react-common";
import { packageMetadata as u } from "../package-metadata.mjs";
const c = t.forwardRef((e, m) => {
  l(u);
  const s = t.useRef(null), r = t.useRef(null), i = t.useCallback(
    () => {
      r.current && r.current.focus();
    },
    [r]
  );
  return t.useImperativeHandle(s, () => ({
    element: r.current,
    focus: i,
    props: e
  })), t.useImperativeHandle(m, () => s.current), /* @__PURE__ */ t.createElement(
    "li",
    {
      ref: r,
      id: e.id,
      style: e.style,
      className: n(
        "k-breadcrumb-item",
        {
          "k-breadcrumb-root-item": e.isFirstItem,
          "k-breadcrumb-last-item": e.isLastItem
        },
        e.className
      )
    },
    e.children
  );
}), d = {
  id: a.string,
  className: a.string,
  children: a.any,
  style: a.object
};
c.displayName = "KendoReactBreadcrumbListItem";
c.propTypes = d;
export {
  c as BreadcrumbListItem
};
